import { globalDexieDb } from "../db/DexiedbLib"
import { getContactsListExtraInfoLocal } from "../db/report/localBackend"
import { isLocalMode } from "../utils/common"
import ApiHelper from "./ApiHelper"


export const ContactsApi = {
    getContactsList: async () => {
        let result = await ApiHelper.get("/contactsList")
        return result
    },
    getContactsListExtraInfo: async (payload) => {
        if (isLocalMode()) {
            return getContactsListExtraInfoLocal(payload);
        }
        else {
            const { ngay } = payload
            const url = `/contact/getListContactExtraInfo?ngay=${ngay}`
            let result = await ApiHelper.get(url)
            return result.data
        }
    },
    getContactsListExtraInfoByContactIds: async (payload) => {
        if (isLocalMode()) {
            //return getListContactExtraInfoByContactIdLocal(payload);
        }
        else {
            const { ngay, contactIds } = payload
            const url = `/contact/getListContactExtraInfoByContactId?ngay=${ngay}&contactId=${contactIds}`
            let result = await ApiHelper.get(url)
            return result.data
        }
    },
    getContactGiaThuong: async (payload) => {
        const [contactId, mienCuPhapId, ngay] = payload
        let url = `contact/getContactGiaThuong?contactId=${contactId}&mienCuPhapId=${mienCuPhapId}&ngay=${ngay}`
        let result = await ApiHelper.get(url)
        return result
    },
    postEditedContact: async (payload) => {
        /*payload: contact, []contactGiaThuong, []contactConfig*/
        // Luôn lưu vào client các tham số này ngay khi edit
        const { config, contact, giaThuong } = payload
        for (let row of contact) {
            globalDexieDb.contacts.put(row)
        }
        for (let row of config) {
            globalDexieDb.contactsConfig.put(row)
        }
        for (let row of giaThuong) {
            globalDexieDb.contactGiaThuong.put(row)
        }

        let url = `contact/postEditedContact`
        let result = await ApiHelper.post(url, payload)
        return result.data
    },
    createNewContact: async (payload) => {
        //const { name, phone } = payload
        let url = `contact/postCreateContact`
        let result = await ApiHelper.post(url, payload)
        return result
    },
    postUserConfig: async (payload) => {
        /*payload:  []userDaiConfig, []userConfig*/

        let url = `config/postUserConfig`
        let result = await ApiHelper.post(url, payload)
        console.log(payload)
        return result.data
    },
    postUserConfigPredef: async (payload) => {
        /*payload:  []userDaiConfig, []userConfig*/

        let url = `config/postUserConfigPredef`
        let result = await ApiHelper.post(url, payload)
        console.log(payload)
        return result.data
    },
    saveDonViTien: async (payload) => {
        /*payload:  []userDaiConfig, []userConfig*/

        let url = `contact/saveDonViTien`
        let result = await ApiHelper.post(url, payload)
        console.log(payload)
        return result.data
    },
    getDonViTien: async (payload) => {      

        let url = `contact/getDonViTienFromCache?contactId=${payload.contactId}`
        let result = await ApiHelper.get(url)
        console.log(payload)
        return result.data
    },
    postCopyContact: async (payload) => {
        /*payload:  {
            "fromContactId":1,
            "name":"new name2",
            "phone":"new phone2"
        
        }*/
        let url = `contact/postCopyContact`
        let result = await ApiHelper.post(url, payload)
        return result.data
    },
    deleteContact: async (payload) => {
        const { contactId } = payload
        let url = `contact/deleteContact?contactId=${contactId}`
        let result = await ApiHelper.delete(url)
        return result.data
    },
    getHanMucJson: async (contactId) => {

        let url = `contact/getHanMucJson?contactId=${contactId}`
        let result = await ApiHelper.get(url)
        return result.data
    },
    saveHanMucJson: async (payload) => {
        /*{
            "contactId":1,
            "JSON":"abcd-iuooiouo",
            "hanMucText":"de 100 con x 100n"
        }*/
        let url = `contact/saveHanMucJson`
        let result = await ApiHelper.post(url, payload)
        return result.data
    },
    getGioChot: async () => {
        let url = `contact/getGioChot`
        let result = await ApiHelper.get(url)
        return result.data
    },
    getDaiQuayTrongNgay: async (payload) => {
        const { ngay } = payload
        let url = `danhmuc/getDaiQuayTrongNgay?ngay=${ngay}`
        let result = await ApiHelper.get(url)
        return result.data
    },
    setGioChot: async (payload) => {
        let url = `contact/setGioChot`
        let result = await ApiHelper.post(url, payload)
        return result.data
    },
    getGuestContactId: async (payload) => {
        let url = `contact/setGioChot`
        let result = await ApiHelper.get(url, payload)
        return result.data
    },
    getChanSoHang: async (payload) => {
        const { ngay } = payload
        let url = `contact/getChanSoHang?ngay=${ngay}`
        let result = await ApiHelper.get(url)
        return result.data
    },
    saveChanSoHang: async (payload) => {

        let url = `contact/saveChanSoHang`
        let result = await ApiHelper.post(url, payload)
        return result.data
    },
    saveChanDai: async (payload) => {

        let url = `contact/saveChanDai`
        let result = await ApiHelper.post(url, payload)
        return result.data
    },
    getBotConfig: async (payload) => {
        let url = `bot/getBotConfig`
        let result = await ApiHelper.get(url, payload)
        return result.data
    },
    setBotConfig: async (payload) => {
        let url = `bot/setBotConfig`
        let result = await ApiHelper.post(url, payload)
        return result.data
    },
    getCongNoDateRangeForSave: async () => {
        const url = `/contact/getCongNoDateRangeForSave`
        const result = await ApiHelper.get(url)
        return result.data
    },
    getDanhSachNhomTele: async () => {
        const url = `/bot/getDanhSachNhomTele`
        const result = await ApiHelper.get(url)
        return result.data
    },
    sendMsgToAllGroup: async (payload) => {
        const {text} = payload
        let url = `bot/sendMessageToAllGroup?text=${text}`
        let result = await ApiHelper.post(url, null)
        return result.data
    },
    getMessageIdsByContact: async (payload) => {
        const {contactId} = payload
        const url = `/contact/getMessageIdsByContact?contactId=${contactId}`
        const result = await ApiHelper.get(url)
        return result.data
    },
    updateContactOrder: async (payload) => {
        // order  = [{contactId:1, newSortOrder:1}, {contactId:2, newSortOrder:2},]
        const {order} = payload
        const url = `/contact/updateContactOrder`
        const result = await ApiHelper.post(url, order)
        return result.data
    }
}